import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import * as React from 'react'
import { useCustomLogoQuery } from '../../hooks/useCustomLogoQuery'

function Seo({ description, title, children, ogImage, imageAltText, type = 'website', imageWidth = 1200, imageHeight = 630, path }) {
  const relativeImageUrl = useCustomLogoQuery()

  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
    }
  `)

  const metaDescription = description || site.siteMetadata.description

  const defaultTitle = site.siteMetadata?.title
  const gId = 'G-EE410PWSTT'
  
  // Ensure image URL is absolute
  let absoluteImageUrl = ogImage || relativeImageUrl
  if (absoluteImageUrl && !absoluteImageUrl.startsWith('http')) {
    absoluteImageUrl = `${site.siteMetadata.siteUrl}${absoluteImageUrl}`
  }
  
  const altText = (ogImage && imageAltText) || 'Byggframtid Logo'
  
  // Create canonical URL using the path prop or default to '/' if not provided
  const canonical = `${site.siteMetadata.siteUrl}${path || '/'}`

  return (
    <>
      <script
        async=""
        src={`https://www.googletagmanager.com/gtag/js?id=${gId}`}
      ></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gId}');`}
      </script>

      <title>
        {title} | {defaultTitle}
      </title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:alt" content={altText} />
      <meta property="og:image:width" content={imageWidth.toString()} />
      <meta property="og:image:height" content={imageHeight.toString()} />
      <link rel="canonical" href={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={absoluteImageUrl} />
      <meta property="twitter:image:alt" content={altText} />

      {children}
    </>
  )
}

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  ogImage: PropTypes.string,
  imageAltText: PropTypes.string,
  type: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  path: PropTypes.string
}

export default Seo
